export type PaletteKey =
  | 'sauge'
  | 'ocean'
  | 'crepuscule'
  | 'aurore'
  | 'ardoise'
  | 'lavande'
  | 'sable'
  | 'foret'
  | 'brume'
  | 'corail';

export type Palette = {
  key: PaletteKey;
  name: string;
  tagline: string;
  sidebar: string;
  nav: string;
  bg: string;
  sage: string;       // accent principal
  terracotta: string; // accent secondaire
  btnVoir: string;
  btnValider: string;
  btnRevoir: string;
  textMain: string;
  textMuted: string;
  border: string;
  pagesScrollBg: string; // fond zone PDF
};

export const PALETTES: Record<PaletteKey, Palette> = {
  sauge: {
    key: 'sauge',
    name: 'Sauge',
    tagline: 'Doux et naturel (défaut)',
    sidebar: '#587D62',
    nav: '#F0EDE5',
    bg: '#FAFAF5',
    sage: '#81B29A',
    terracotta: '#E07A5F',
    btnVoir: '#A8C8B4',
    btnValider: '#8CB369',
    btnRevoir: '#D48C3E',
    textMain: '#3D5A45',
    textMuted: '#A9A193',
    border: '#DDD8CE',
    pagesScrollBg: '#E5E1D5',
  },
  ocean: {
    key: 'ocean',
    name: 'Océan',
    tagline: 'Bleu calme et profond',
    sidebar: '#3C6E85',
    nav: '#E8EEF2',
    bg: '#F6F9FB',
    sage: '#5B9BAE',
    terracotta: '#E89B68',
    btnVoir: '#A7C6D1',
    btnValider: '#6FA7B8',
    btnRevoir: '#D48940',
    textMain: '#1F3A4A',
    textMuted: '#8FA4AE',
    border: '#CFDAE1',
    pagesScrollBg: '#D6DFE5',
  },
  crepuscule: {
    key: 'crepuscule',
    name: 'Crépuscule',
    tagline: 'Mauve doré, fin de journée',
    sidebar: '#5A4A6B',
    nav: '#EFECF2',
    bg: '#FAF8FC',
    sage: '#8B7AA8',
    terracotta: '#D9A860',
    btnVoir: '#BEB1D1',
    btnValider: '#8272A0',
    btnRevoir: '#C28E3C',
    textMain: '#342847',
    textMuted: '#A49AAF',
    border: '#DDD5E3',
    pagesScrollBg: '#DDD5E3',
  },
  aurore: {
    key: 'aurore',
    name: 'Aurore',
    tagline: 'Rose pêche, début de journée',
    sidebar: '#9A5A6A',
    nav: '#F5ECEE',
    bg: '#FCF7F6',
    sage: '#C98790',
    terracotta: '#E8A175',
    btnVoir: '#E3B7BD',
    btnValider: '#C77683',
    btnRevoir: '#D88A4C',
    textMain: '#5A2B36',
    textMuted: '#B39698',
    border: '#E5D4D7',
    pagesScrollBg: '#E5D4D7',
  },
  ardoise: {
    key: 'ardoise',
    name: 'Ardoise',
    tagline: 'Gris minéral, épuré',
    sidebar: '#4A5568',
    nav: '#EDEFF2',
    bg: '#F7F9FB',
    sage: '#718096',
    terracotta: '#C8A25A',
    btnVoir: '#B9C2CD',
    btnValider: '#677589',
    btnRevoir: '#B88E3D',
    textMain: '#2D3748',
    textMuted: '#99A2B0',
    border: '#D4DAE1',
    pagesScrollBg: '#D4DAE1',
  },
  lavande: {
    key: 'lavande',
    name: 'Lavande',
    tagline: 'Violet poudré',
    sidebar: '#6E5A8C',
    nav: '#EFECF5',
    bg: '#F9F7FC',
    sage: '#9A8BC0',
    terracotta: '#D89A5A',
    btnVoir: '#C4BAD9',
    btnValider: '#8978B0',
    btnRevoir: '#C58340',
    textMain: '#3D2E5C',
    textMuted: '#A8A0B8',
    border: '#DCD6E5',
    pagesScrollBg: '#DCD6E5',
  },
  sable: {
    key: 'sable',
    name: 'Sable',
    tagline: 'Beige doré, désert',
    sidebar: '#8A6F4C',
    nav: '#F4EDE2',
    bg: '#FAF5ED',
    sage: '#B89968',
    terracotta: '#D97C5A',
    btnVoir: '#D8C8A7',
    btnValider: '#A88548',
    btnRevoir: '#C56638',
    textMain: '#523F28',
    textMuted: '#AE9F88',
    border: '#E0D5C0',
    pagesScrollBg: '#E0D5C0',
  },
  foret: {
    key: 'foret',
    name: 'Forêt',
    tagline: 'Vert profond',
    sidebar: '#2E4A36',
    nav: '#E8EEE8',
    bg: '#F6F9F6',
    sage: '#5F8A6B',
    terracotta: '#C8764D',
    btnVoir: '#A5BFA9',
    btnValider: '#4F7458',
    btnRevoir: '#B76536',
    textMain: '#1E3025',
    textMuted: '#8CA297',
    border: '#CDDCCF',
    pagesScrollBg: '#CDDCCF',
  },
  brume: {
    key: 'brume',
    name: 'Brume',
    tagline: 'Gris-vert neutre',
    sidebar: '#607070',
    nav: '#ECEEEB',
    bg: '#F7F9F7',
    sage: '#8FA39A',
    terracotta: '#C99275',
    btnVoir: '#B9C6C1',
    btnValider: '#6C8680',
    btnRevoir: '#B67B56',
    textMain: '#2E3A38',
    textMuted: '#9DA7A4',
    border: '#D4D8D4',
    pagesScrollBg: '#D4D8D4',
  },
  corail: {
    key: 'corail',
    name: 'Corail',
    tagline: 'Orange chaleureux',
    sidebar: '#B0553E',
    nav: '#F4EBE6',
    bg: '#FCF6F1',
    sage: '#D9866A',
    terracotta: '#C49358',
    btnVoir: '#EAB9A8',
    btnValider: '#B15C3C',
    btnRevoir: '#A97F40',
    textMain: '#5A251A',
    textMuted: '#B99281',
    border: '#E6D3CA',
    pagesScrollBg: '#E6D3CA',
  },
};

export const DEFAULT_PALETTE: PaletteKey = 'sauge';

export function isValidPaletteKey(s: string | null | undefined): s is PaletteKey {
  return !!s && s in PALETTES;
}
